import React from 'react'
import { ButtonContainer, TabButton } from '~/components/shared/TabNav'
import { useIsMobile } from '~/hooks/useMediaQuery'

const Wrapper = ({ children }) => {
  const isMobile = useIsMobile()
  if (isMobile) return children

  return (
    <div className="relative w-full overflow-x-scroll sm:static sm:overflow-auto">
      {children}
    </div>
  )
}

const TabNavButtons = () => {
  const isMobile = useIsMobile()
  const titleClass = isMobile ? '' : 'text-sm mx-0 md:mx-0 lg:mx-0'

  return (
    <Wrapper>
      <ButtonContainer
        carouselWrapperClass="min-h-[4.5rem] mb-8"
        className="mb-6 flex flex-row justify-between gap-5 min-[530px]:justify-start min-[530px]:gap-10"
        buttonClass="min-w-16"
        titleClass={titleClass}
      >
        <TabButton
          activeDecorationClass="bg-intoo-green-coachcta"
          name="prioritized_tasks"
          text="Prioritized Tasks"
        />
        <TabButton
          activeDecorationClass="bg-intoo-green-coachcta"
          name="upcoming_meetings"
          text="Upcoming Meetings"
        />
        <TabButton
          activeDecorationClass="bg-intoo-green-coachcta"
          name="tasks_due"
          text="Tasks Due"
        />
        <TabButton
          activeDecorationClass="bg-intoo-green-coachcta"
          name="past_due_tasks"
          text="Past Due Tasks"
        />
      </ButtonContainer>
    </Wrapper>
  )
}
export default TabNavButtons
